module.exports = __webpack_public_path__ + "static/media/Earth.dadf34e9.png";